/**
 *
 * Asynchronously loads the component for TaxForms
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
